const EBroadcast = {
  Badge: "1",
  MobileSearchFilter: "4",
  DmGroups: "5",
} as const;

type EBroadcast = typeof EBroadcast[keyof typeof EBroadcast];

export { EBroadcast };
